'use client'

import styled from "styled-components";
import {getColor} from "@/pipes/theme.pipe";
import Modal from "@/components/UI/Containers/Modal/Modal";
import Title from "@/components/UI/Title/Title";
import Description from "@/components/UI/Description/Description";
import BaseInput from "@/components/UI/Form/Inputs/BaseInput/BaseInput";
import Button from "@/components/UI/Button/Button";
import Form from "@/components/UI/Form/Form/Form";


export const VerifyEmail = styled(Modal)`
    max-width: 610px;

    .ant-modal-content {
        padding: 40px 70px;
    }
`

export const VerifyEmailTitleDescWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 27px;
    width: 100%;
`

export const VerifyEmailTitle = styled(Title).attrs({
    size: 'sm'
})`
    font-size: 24px;
`
export const VerifyEmailDescription = styled(Description).attrs({
    size: 'sm'
})``

export const VerifyEmailForm = styled(Form)`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: clamp(15px, 2vw, 30px);
`

export const VerifyEmailInput = styled(BaseInput)`
    margin-top: 50px;
`

export const ResendButton = styled(Button).attrs({
    variant: 'link',
})`
    text-decoration: underline;
    color: ${getColor('primary', '500')} !important;
    font-size: 14px;
`

export const SubmitButton = styled(Button).attrs({
    size: 'md',
})`
    font-size: 14px;
    padding: 15px 40px;
    letter-spacing: 1px;
`